<script setup lang="ts">
import { ref, computed, inject } from "vue";
import { TranslationService } from "../services/translation.service";

const t = (inject<TranslationService>("translationSvc") as TranslationService)
    .t;

const { title, newsEntries, categories, categoryLimit, allNewsLimit } =
    defineProps({
        title: {
            type: String,
            required: true,
        },
        newsEntries: {
            type: Array,
            required: true,
        },
        categories: {
            type: Array,
            required: true,
        },
        categoryLimit: {
            type: Number,
            required: false,
            default: undefined,
        },
        allNewsLimit: {
            type: Number,
            required: false,
            default: undefined,
        },
        isTeaser: {
            type: Boolean,
            required: false,
            default: false,
        },
    });

const chosenCategory = ref("");

const slicedNewsEntriesSidebar = computed(() => {
    return newsEntries.slice(0, allNewsLimit);
});

const slicedNewsEntries = computed(() => {
    return newsEntries
        .filter(
            (item) =>
                item.category === chosenCategory.value ||
                chosenCategory.value === "",
        )
        .slice(0, categoryLimit);
});

const changeCategory = (category) => {
    // Implement the logic to change the category
    chosenCategory.value = category;
};

const generateUrl = () => {
    // Implement the logic to generate the URL based on site handle and item ID
    return `test`;
};
</script>

<template>
    <div class="grid-css">
        <div class="row-xl-0-1 col-xl-2-15 col-m-2-22">
            <h2>{{ title }}</h2>
        </div>

        <div class="row-xl-1-2 col-xl-2-15 col-m-2-22">
            <div class="categories-bar mt-15 mb-15" style="text-align: left">
                <ul>
                    <li
                        class="categories-bar-item"
                        v-for="(item, index) in categories"
                        :class="{ active: chosenCategory === item.slug }"
                        @click="changeCategory(item.slug)"
                    >
                        <span>
                            {{ item.title }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="row-xl-2-3 col-xl-2-15 col-m-2-22">
            <div class="grid-flex flex-spaced__abs flex-vspaced">
                <div
                    v-for="item in slicedNewsEntries"
                    :key="item.id"
                    class="col-xl-12 col-s-24"
                >
                    <a
                        class="grid-css news-preview-big box-shadow"
                        :href="item.url"
                    >
                        <div class="row-xl-0-1 col-xl-0-24">
                            <div
                                class="bg-img__4-3"
                                :style="{
                                    backgroundImage: `url(${item.mainImage})`,
                                }"
                            ></div>
                        </div>
                        <div
                            class="row-xl-1-2 col-xl-0-24 news-preview-big-text"
                        >
                            <div class="normal text-small color-cb">
                                {{ item.postDate }}
                            </div>
                            <div class="h2 mt-8 mb-10">{{ item.title }}</div>
                            <p class="normal text-small" v-html="item.lead"></p>
                        </div>
                        <div
                            class="cell-right cell-bottom row-xl-2-3 col-xl-0-24 news-preview-big-link"
                        >
                            <div class="link-with-plus bold">
                                {{ t("WEITERLESEN") }}
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <!-- News sidebar -->
        <div
            v-if="isTeaser"
            class="row-xl-0-3 col-xl-16-21 hide-m hide-s hide-xs"
        >
            <h2 class="mb-m-15">{{ t("NEWS_ALL_NEWS") }}</h2>
            <div class="categories-bar-placeholder mt-15 mb-15"></div>
            <div>
                <a
                    class="news-preview-small"
                    v-for="item in slicedNewsEntriesSidebar"
                    :key="item.id"
                    :href="item.url"
                >
                    <div class="news-preview-small-img">
                        <div
                            class="bg-img__16-10"
                            :style="{
                                backgroundImage: `url(${item.mainImage})`,
                            }"
                        ></div>
                    </div>
                    <div class="news-preview-small-text">
                        <div class="normal text-small color-cb">
                            {{ item.postDate }}
                        </div>
                        <div class="bold">{{ item.title }}</div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
